
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconCalendar } from '@ds/icons/IconCalendar'
import { IconLock } from '@ds/icons/IconLock'
import { IconLockUnlocked } from '@ds/icons/IconLockUnlocked'
import { IconQuality } from '@ds/icons/IconQuality'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'
import { trackClick } from '@tracking/events'

import VerifiedRefurbishedModal from '../VerifiedRefurbishedModal'

import translations from './ReassuranceItems.translations'
import ReassuranceModal from './components/ReassuranceModal'

const DATE_FORMAT = {
  month: 'short',
  day: 'numeric',
}

export default {
  components: {
    IconBadge,
    IconCalendar,
    IconQuality,
    IconLock,
    IconLockUnlocked,
    IconTruckExpress,
    RevLink,
    RevDivider,
    RevIllustration,
    FormattedMessage,
    ReassuranceModal,
    VerifiedRefurbishedModal,
  },

  props: {
    carriers: {
      type: Array,
      required: true,
    },

    shipping: {
      type: Object,
      required: true,
    },

    warrantyDelay: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
      country: 'config/country',
      experiments: 'flags/getExperiments',
    }),
    translations: () => translations,

    itemContainerClassNames() {
      return 'flex flex-row items-center'
    },
    iconClassNames() {
      return 'w-[40px] h-[40px] flex-shrink-0 rounded-sm mr-3 bg-info-ultralight border border-neutral text-info flex items-center justify-center'
    },

    shouldDisplayCarriers() {
      return !isEmpty(this.carriers)
    },

    shouldDisplayVersionB() {
      return this.experiments.ppReassuranceNewDesign === 'newDesign'
    },

    shouldDisplayVersionC() {
      return this.experiments.ppReassuranceNewDesign === 'newDesignMergedInfo'
    },

    shouldDisplayVerifiedRefurbishedCampaign() {
      return (
        this.$config.FF_PRODUCT_VERIFIED_REFURBISHED_CAMPAIGN ?? ''
      ).includes(this.country)
    },

    shouldDisplayFreeShipping() {
      return !isEmpty(this.shipping.free)
    },

    shouldDisplayExpressShipping() {
      if (!isEmpty(this.shipping.express)) {
        return Number(this.shipping.express.price.amount) > 0
      }

      return false
    },

    freeEarliestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.free.earliestArrivalDate),
        DATE_FORMAT,
      )
    },

    freeLatestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.free.latestArrivalDate),
        DATE_FORMAT,
      )
    },

    expressEarliestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.express.earliestArrivalDate),
        DATE_FORMAT,
      )
    },

    expressLatestArrivalDate() {
      return this.$t.date(
        new Date(this.shipping.express.latestArrivalDate),
        DATE_FORMAT,
      )
    },

    expressShippingPriceLabel() {
      return this.$t.price(this.shipping.express.price)
    },

    isSimLocked() {
      return this.carriers.some((carrier) => carrier.isSimLocked)
    },

    blogLink() {
      return {
        type: 'external',
        href: 'https://help.backmarket.com/hc/en-us/articles/360012437860',
      }
    },
  },
  methods: {
    deploySatisfactionModal() {
      openModal(MODAL_NAMES.REASSURANCE.SATISFACTION)
    },
    deployReassuranceModal() {
      openModal(MODAL_NAMES.PRODUCT.REASSURANCE)
    },
    deployVerifiedRefurbishedModal() {
      openModal(MODAL_NAMES.PRODUCT.VERIFIED_REFURBISHED)
    },
    trackCarriersLinkClick() {
      trackClick({
        zone: 'carrier_compatibility',
        name: 'carrier_info',
      })
    },
  },
}
